import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProcessosSeletivosService {

  baseApiPath: any = localStorage.getItem('base_url');
  headers: any;

  constructor(public http: HttpClient) {
    this.headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'); 
  }

  getAll() {
    return this.http.get(this.baseApiPath + '/processos-seletivos'); 
  }

  getAllEtapas(id) {
    return this.http.get(this.baseApiPath + '/processos-seletivos-etapas/' + id); 
  }

  get(id) { 
    return this.http.get(this.baseApiPath + '/processo-seletivo/' + id);
  }

  post(data) {
    return this.http.post(this.baseApiPath + '/usuario', data, this.headers);
  }

  postVincular(data) {
    return this.http.post(this.baseApiPath + '/processo-seletivo-vincular/', data, this.headers);
  }

  trocaPosicao(data, id) {
    return this.http.put(this.baseApiPath + '/troca-posicao/' + id, data, this.headers);
  }

  edit(data, id) {
    return this.http.put(this.baseApiPath + '/usuario/' + id, data, this.headers);
  }

  delete(id) {
    return this.http.delete(this.baseApiPath + '/usuario/' + id, this.headers);
  }

}
